<template>
    <div>
        <div class="row text-center">
            <div class="col-lg-3 col-12 mt-2 d-inline-block">
                <div class="input-group">
                    <div class="input-group-prepend">
                        <span class="input-group-text">بانک :</span>
                    </div>
                    <vs-select :data="banks" :mode="'create'"
                               :header="{multiple: false, label: 'title'}"
                               @onChange="onChange"></vs-select>
                </div>
            </div>
            <div class="col-lg-3 col-12 mt-2 d-inline-block">
                <div class="input-group">
                    <div class="input-group-prepend">
                        <span class="input-group-text">صندوق :</span>
                    </div>
                    <vs-select :data="cashDesks" :mode="'create'"
                               :header="{multiple: false, label: 'title'}"
                               @onChange="onChange2"></vs-select>
                </div>
            </div>
            <div class="col-lg-6 col-12 mt-2">
                <div class=" d-inline-block mx-3">
                    <div class="input-group mb-2">
                        <div class="input-group-prepend" @click="toggleStartDatePicker">
                            <div class="input-group-text"><span>از تاریخ :</span></div>
                        </div>
                        <date-picker type="date" :auto-submit="true" format="jYYYY-jMM-jDD" @input="onStartDatePicked"
                                     ref="datePickerStart" style="flex: 1">
                            <slot>
                                <input v-model="startDatePersian" class="form-control date-input" readonly="true"
                                       @click="toggleStartDatePicker">
                                <button class="close reset-date" @click="resetStartDate">×</button>
                            </slot>
                        </date-picker>
                    </div>
                </div>
                <div class="d-inline-block mx-3">
                    <div class="input-group mb-2">
                        <div class="input-group-prepend" @click="toggleEndDatePicker">
                            <div class="input-group-text"><span>تا تاریخ :</span></div>
                        </div>
                        <date-picker type="date" :auto-submit="true" :disable="startDatePersian" format="jYYYY-jMM-jDD"
                                     @input="onEndDatePicked"
                                     ref="datePickerEnd" style="flex: 1; transform">
                            <slot>
                                <input v-model="endDatePersian" class="form-control date-input" readonly="true"
                                       @click="toggleEndDatePicker">
                                <button class="close reset-date" @click="resetEndDate">×</button>
                            </slot>
                        </date-picker>
                    </div>
                </div>
                <!--<div class="d-inline-block mx-3">-->
                <!--<button class="btn btn-primary" @click="getReport">ثبت</button>-->
                <!--</div>-->
            </div>
        </div>
        <hr/>
        <div class="row" v-if="listView">
            <div class="col-lg-8 offset-lg-2" v-for="(item, index) in transactions">
                <div class="card list" @click="onCardClicked($event, index)">
                    <div class="row">
                        <!--<div class="col-md-3">-->
                            <!--<strong>{{item.factor}}</strong>-->
                        <!--</div>-->
                        <div class="col-md-5">
                            <strong>حساب: </strong>
                            <span>{{item.account}}</span>
                        </div>
                        <div class="col-md-3">
                            <strong>تاریخ: </strong>
                            <span>{{item.persianDate}}</span>
                        </div>
                        <div class="col-md-3">
                            <strong>مبلغ: </strong>
                            <span>{{item.creditor.toLocaleString()}}</span>
                        </div>
                        <div class="col-md-1">
                            <button type="button" class="btn btn-danger" @click="onDeleteClicked(item)"><i class="fa fa-trash"></i></button>
                        </div>
                        <div class="col-md-12">
                            <strong>توضیحات : </strong>
                            <span>{{item.description}}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row" v-else>
            <div class="col-lg-4 col-sm-6 product-container" v-for="(item, index) in transactions">
                <div class="card transaction mt-2 mb-2" @click="onCardClicked($event, index)">
                    <div class="card-header">
                        <h4 class="text-center">{{item.factor}}</h4>
                    </div>
                    <div class="card-body">
                        <div class="text-center text-danger">
                            <h5 class="d-inline">مبلغ: </h5>
                            <h5 class="d-inline">{{item.creditor.toLocaleString()}}</h5>
                        </div>
                        <span><b>حساب: </b></span>
                        <span>{{item.account}}</span>
                        <br>
                        <span><b>توضیحات: </b></span>
                        <span>{{item.description}}</span>
                        <br>
                        <span><b>تاریخ: </b></span>
                        <span>{{item.persianDate}}</span>
                        <button type="button" style="float: left;" class="btn btn-danger" @click="onDeleteClicked(item)"><i class="fa fa-trash"></i></button>

                        <br>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div v-if="transactions === undefined" class="col-lg-12 text-center mt-5 mb-3">
                <h3 class="no-item-alert">گزارشی یافت نشد!</h3>
            </div>
            <div v-if="transactions !== undefined && transactions.length < dataCount" class="col-lg-12 text-center my-3">
                <button class="btn btn-success"  @click="getTransactions">نمایش تراکنش های بیشتر
                    ({{transactions.length}}/{{dataCount}})</button>
                <div class="col-2 offset-5 my-2">
                    <div class="input-group">
                        <div class="input-group-prepend">
                            <span class="input-group-text">تعداد نمایش</span>
                        </div>
                        <input class="form-control" type="text" @change="changePageSize" v-model="queryParams.pageSize">
                    </div>
                </div>
            </div>
            <div class="col-lg-12">
                <div class="sk-circle" id="loading">
                    <div class="sk-circle1 sk-child"></div>
                    <div class="sk-circle2 sk-child"></div>
                    <div class="sk-circle3 sk-child"></div>
                    <div class="sk-circle4 sk-child"></div>
                    <div class="sk-circle5 sk-child"></div>
                    <div class="sk-circle6 sk-child"></div>
                    <div class="sk-circle7 sk-child"></div>
                    <div class="sk-circle8 sk-child"></div>
                    <div class="sk-circle9 sk-child"></div>
                    <div class="sk-circle10 sk-child"></div>
                    <div class="sk-circle11 sk-child"></div>
                    <div class="sk-circle12 sk-child"></div>
                </div>
            </div>
            <!--<div class="modal fade" id="voucherData" tabindex="-1" role="dialog" aria-labelledby="voucherTitle" aria-hidden="true">
                <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
                    <div class="modal-content">
                        <div class="modal-header bg-warning-grad glow-warning">
                            <h5 class="modal-title text-white" id="voucherTitle">محصولات فاکتور</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <div class="table-responsive">
                                <table class="table table-hover table-striped">
                                    <thead>
                                    <tr>
                                        <th>نام محصول</th>
                                        <th class="text-center">قیمت خرید</th>
                                        <th class="text-center">تعداد</th>
                                        <th class="text-center">قیمت فروش</th>
                                    </tr>
                                    </thead>
                                    <tbody v-if="voucher !== undefined">
                                    <tr v-for="(item,index) in voucher.products">
                                        &lt;!&ndash;<td class="product-remove-button"><a class="text-danger" @click="onRemoveProductClicked(index)"><i class="fa fa-close"></i></a></td>&ndash;&gt;
                                        <td>{{item.productName}}</td>
                                        <td class="text-center">
                                            {{item.price}}
                                        </td>
                                        <td class="text-center">
                                            {{item.unitVal}}
                                        </td>
                                        <td class="text-center">
                                            {{item.salesPrice}}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="text-left"><b>جمع</b></td>
                                        <td class="text-center" v-if="voucher.voucher !== undefined">
                                            <b>{{voucher.voucher.price}}</b>
                                        </td>
                                        <td class="text-center"><b>{{overallAmount}}</b></td>
                                        <td></td>
                                    </tr>
                                    </tbody>
                                </table>
                                <h4 class="text-center mt-5" v-if=" voucher.products !== undefined && voucher.products.length < 1">محصولی ثبت نشده است!</h4>
                            </div>
                            <div class="input-group mt-2">
                                <div class="input-group-prepend">
                                    <span class="input-group-text">توضیحات</span>
                                </div>
                                <input v-if="voucher.voucher !== undefined" class="form-control" type="text" v-model="voucher.voucher.description" placeholder="توضیحات" disabled>
                            </div>
                        </div>
                        <div class="modal-footer d-block">
                            <button type="button" class="btn btn-secondary mr-1" data-dismiss="modal">بستن</button>
                        </div>
                    </div>
                </div>
            </div>-->
        </div>
    </div>
</template>

<script>
    import * as $ from 'jquery';
    import Vue from 'vue';
    import BaseService from "../../_framework/api/BaseService";
    import Utils from "../../_framework/utils/Utils";
    import Moment from "moment-jalali";
    import EventBus from "../../_framework/event-bus.js";
    import DatePicker from '../../components/vue-persian-datetime-picker/VuePersianDatetimePicker.vue';
    import VsSelect from "../../_framework/VsSelect"


    $(function() {
        var pos1 = 0;
        $(window).scroll(function() {
            var pos2 = $(window).scrollTop();
            if(pos2 > pos1) {
                $(".search-area").addClass("hidden");
            }
            if(pos1 > pos2) {
                $(".search-area").removeClass("hidden");
            }
            pos1 = pos2;
        })
    });

    export default {
        name: 'payments-archive',
        components: {
            DatePicker,
            VsSelect,
        },
        data() {
            return {
                transactions: [],
                queryParams: {
                    pageSize: 12,
                    pageIndex: 0,
                    type: 1
                },
                dataCount: 0,

                listView: false,
                fromDate: "",
                fromDateJ: "",
                toDate: "",
                toDateJ: "",
                startDatePersian: "",
                endDatePersian: "",
                providers: [],
                selectedBank: 0,
                selectedCash: 0,
                banks: [],
                cashDesks: [],
            }
        },
        mounted() {
            this.listView = JSON.parse(localStorage.getItem("listView"));
            EventBus.$on('listView', value => {
                this.listView = value;
            });
            new BaseService('reports', '/gettransactionreport').getList(this.queryParams).then(response => {
                this.transactions = response.data.data;
                this.dataCount = response.data.count;
                if (this.transactions !== undefined) {
                    for (let item of this.transactions) {
                        let date = Moment(item.date, 'YYYY-MM-DD').format("jDD jMMMM jYYYY");
                        Vue.set(item, "persianDate", date);
                    }
                }
                $("#loading").hide();
            }).catch(error => {
                Utils.handleErrorWithNotification(error.message, this.$noty);
            });
            this.getProviders();
        },
        methods: {
            changePageSize(e){
                this.getTransactions(-1);
            },
            getTransactions(page) {
                if (page === -1) {
                    this.queryParams.pageIndex = 0;
                    this.transactions =[];
                    this.dataCount = 0;
                } else {
                    this.queryParams.pageIndex++;
                }
                $("#loading").show();
                new BaseService('reports', '/gettransactionreport').getList(this.queryParams).then(response => {
                    this.transactions.push.apply(this.transactions, response.data.data);
                    this.dataCount = response.data.count;
                    for (let item of this.transactions) {
                        let date = Moment(item.date, 'YYYY-MM-DD').format("jDD jMMMM jYYYY");
                        Vue.set(item, "persianDate", date);
                    }
                    $("#loading").hide();
                }).catch(error => {
                    // error
                    Utils.handleErrorWithNotification(error.message, this.$noty);
                });
            },
            onCardClicked(e, index) {
                /*this.overallAmount = 0;
                let id = this.vouchers[index].id;
                new BaseService('voucher', `/getproducts/${id}`).getList().then(response => {
                    this.voucher = response.data;
                    for (let item of this.voucher.products) {
                        this.overallAmount += item.unitVal;
                    }
                    $("#voucherData").modal("show");
                }).catch(error => {
                    Utils.handleErrorWithNotification(error.message, this.$noty);
                })*/
            },
            getProviders() {
                this.queryParams = {
                    pageSize: 80,
                    pageIndex: 0,
                    parrentId: 1
                };
                new BaseService('accountTitle', '/getAll').getList(this.queryParams).then(response => {
                    this.banks = response.data;
                    // console.log(this.banks);
                    let allPro = {
                        id: 0,
                        title: "همه بانکها"
                    };
                    this.banks.push(allPro);
                }).catch(error => {
                    // error
                    Utils.handleErrorWithNotification(error.message, this.$noty);
                });
                this.queryParams = {
                    pageSize: 80,
                    pageIndex: 0,
                    parrentId: 2
                };
                new BaseService('accountTitle', '/getAll').getList(this.queryParams).then(response => {
                    this.cashDesks = response.data;
                    let allPro = {
                        id: 0,
                        title: "همه صندوق ها"
                    };
                    this.cashDesks.push(allPro);
                }).catch(error => {
                    // error
                    Utils.handleErrorWithNotification(error.message, this.$noty);
                });
                this.queryParams = {
                    pageSize: 12,
                    pageIndex: 0,
                    name: "",
                    types: 1
                };

            },
            toggleStartDatePicker() {
                this.$refs.datePickerStart.togglePicker();
            },
            toggleEndDatePicker() {
                this.$refs.datePickerEnd.togglePicker();
            },
            onStartDatePicked(val) {
                this.fromDate = Moment(val, 'jYYYY-jMM-jDD').format('YYYY-MM-DD');
                this.startDatePersian = Moment(val, 'jYYYY-jMM-jDD').format('jDD jMMMM jYYYY');
            },
            onEndDatePicked(val) {
                this.toDate = Moment(val, 'jYYYY-jMM-jDD').format('YYYY-MM-DD');
                this.endDatePersian = Moment(val, 'jYYYY-jMM-jDD').format('jDD jMMMM jYYYY');
                this.getReport();
            },
            resetStartDate() {
                this.fromDate = '';
                this.startDatePersian = '';
            },
            resetEndDate() {
                this.toDate = '';
                this.endDatePersian = '';
            },
            getReport() {
                this.queryParams = {
                    accountTitleId: this.selectedBank !== 0 ? this.selectedBank : this.selectedCash ,
                    fromdate: this.fromDate,
                    toDate: this.toDate,
                    pageSize: 12,
                    pageIndex: 0,
                    type: 1

                };
                new BaseService('reports', '/gettransactionreport').getList(this.queryParams).then(response => {
                    this.transactions = response.data.data;
                    this.dataCount = response.data.count;
                    if (this.transactions !== undefined) {
                        for (let item of this.transactions) {
                            let date = Moment(item.date, 'YYYY-MM-DD').format("jDD jMMMM jYYYY");
                            Vue.set(item, "persianDate", date);
                        }
                    }
                    $("#loading").hide();
                }).catch(error => {
                    Utils.handleErrorWithNotification(error.message, this.$noty);
                });

            },
            onChange(val) {
                this.selectedBank = val.id;
                this.selectedCash = 0;
                this.queryParams = {
                    accountTitleId: val.id,
                    pageSize: 12,
                    pageIndex: 0,
                    type: 1
                };
                new BaseService('reports', '/gettransactionreport').getList(this.queryParams).then(response => {
                    this.transactions = response.data.data;
                    this.dataCount = response.data.count;
                    if (this.transactions !== undefined) {
                        for (let item of this.transactions) {
                            let date = Moment(item.date, 'YYYY-MM-DD').format("jDD jMMMM jYYYY");
                            Vue.set(item, "persianDate", date);
                        }
                    }
                    $("#loading").hide();
                }).catch(error => {
                    Utils.handleErrorWithNotification(error.message, this.$noty);
                });
            },
            onChange2(val) {
                this.selectedBank = 0;
                this.selectedCash = val.id;
                this.queryParams = {
                    accountTitleId: val.id,
                    pageSize: 12,
                    pageIndex: 0,
                    type: 1
                };
                new BaseService('reports', '/gettransactionreport').getList(this.queryParams).then(response => {
                    this.transactions = response.data.data;
                    this.dataCount = response.data.count;
                    if (this.transactions !== undefined) {
                        for (let item of this.transactions) {
                            let date = Moment(item.date, 'YYYY-MM-DD').format("jDD jMMMM jYYYY");
                            Vue.set(item, "persianDate", date);
                        }
                    }
                    $("#loading").hide();
                }).catch(error => {
                    Utils.handleErrorWithNotification(error.message, this.$noty);
                });
            },
            onDeleteClicked(item) {
                if (confirm("آیا از حذف اطمینان دارید؟ \n اگر بابت خرید یا فروش باشد فاکتورها نیز حذف خواهند شد")) {
                    if (!this.isSending) {
                        this.isSending = true;


                        new BaseService('voucher', `/DeleteVoucher/${item.voucherId}`).create().then(response => {
                            this.$noty.warning("با موفقیت حذف شد!");
                            this.queryParams = {
                                pageSize: 9,
                                pageIndex: 0,
                                type: 1
                            };
                            new BaseService('reports', '/gettransactionreport').getList(this.queryParams).then(response => {
                                this.transactions = response.data.data;
                                this.dataCount = response.data.count;
                                if (this.transactions !== undefined) {
                                    for (let item of this.transactions) {
                                        let date = Moment(item.date, 'YYYY-MM-DD').format("jDD jMMMM jYYYY");
                                        Vue.set(item, "persianDate", date);
                                    }
                                }
                                $("#loading").hide();
                            }).catch(error => {
                                Utils.handleErrorWithNotification(error.response.message, this.$noty);
                            });
                            this.isSending = false;
                        }).catch(error => {
                            this.isSending = false;
                            Utils.handleErrorWithNotification(error.message, this.$noty);
                        });
                    }
                }
            },




        }
    }
</script>